import { Fragment } from "react";
import StatusTag from "../../../components/common/StatusTag";
import { AccessLevel, ROLE_ACCESS_ROWS, ROLE_COLUMNS } from "./roleAccessMatrixData";
import "./RoleAccessMatrix.css";

const ACCESS_LEVEL_TO_STATUS: Record<AccessLevel, { color: string; label: string }> = {
  full: { color: "green", label: "Full" },
  read: { color: "yellow", label: "Read-only" },
  none: { color: "gray", label: "No access" },
};

const RoleAccessMatrix = () => {
  const groups: string[] = [];
  ROLE_ACCESS_ROWS.forEach((row) => {
    if (groups[groups.length - 1] !== row.group) {
      groups.push(row.group);
    }
  });

  return (
    <div className="role-access-matrix-container">
      <p className="heading black role-access-matrix-title">What each role can access</p>
      <p className="sub_text role-access-matrix-subtitle">
        Full access, read-only access, or no access at all, module by module.
      </p>

      <div className="role-access-matrix-scroll">
        <table className="role-access-matrix">
          <thead className="role-access-matrix-thead">
            <tr>
              <th className="role-access-matrix-module-col">Module</th>
              {ROLE_COLUMNS.map((col) => (
                <th key={col.key}>{col.label}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {groups.map((group) => (
              <Fragment key={group}>
                <tr className="role-access-matrix-group-row">
                  <th colSpan={ROLE_COLUMNS.length + 1}>{group}</th>
                </tr>
                {ROLE_ACCESS_ROWS.filter((row) => row.group === group).map((row) => (
                  <tr key={row.module}>
                    <th className="role-access-matrix-module-col">{row.module}</th>
                    {ROLE_COLUMNS.map((col) => {
                      const status = ACCESS_LEVEL_TO_STATUS[row[col.key]];
                      return (
                        <td key={col.key}>
                          <StatusTag color={status.color} statusText={status.label} isLarge={false} />
                        </td>
                      );
                    })}
                  </tr>
                ))}
              </Fragment>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default RoleAccessMatrix;
